"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionButton = exports.OptionSelector = OptionSelector;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _index = require("../../fuse-swatch/src/index");
var _typography = require("../../fuse-typography-element/src/typography");
var _excluded = ["dataTestId", "id", "name", "label", "swatchColour", "swatchImage"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var propTypes = {
  id: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  dataTestId: _propTypes["default"].string,
  swatchImage: _propTypes["default"].string,
  swatchColour: _propTypes["default"].string,
  disabled: _propTypes["default"].bool
};
var defaultProps = {
  dataTestId: null,
  swatchImage: undefined,
  swatchColour: undefined,
  disabled: false
};
var StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "src__StyledInput",
  componentId: "sc-15hfvdh-0"
})(["position:absolute;width:0;height:0;opacity:0;"]);
var StyledLabel = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  tag: 'label',
  size: 'm1',
  type: 'paragraph'
}).withConfig({
  displayName: "src__StyledLabel",
  componentId: "sc-15hfvdh-1"
})(["margin:0;padding:0 var(--spacing-global-space4);border-radius:8px;border:1px solid var(--color-functional-divider);cursor:pointer;height:48px;align-items:center;display:flex;align-items:center;justify-content:center;span{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}", " &:hover{border-color:var(--color-global-grey700);}input:checked + &&{border-color:var(--color-brand-mid);}input:not(:disabled) + &&:active{background:var(--color-brand-mid);border-color:var(--color-brand-mid);color:var(--color-global-white);outline:2px solid var(--color-functional-focus);outline-offset:2px;}input:focus + &&{outline:2px solid var(--color-functional-focus);outline-offset:2px;}input:focus:not(:focus-visible) + &&{outline:none;}input:focus-visible + &&{outline:2px solid var(--color-functional-focus);outline-offset:2px;}input:disabled + &&{cursor:default;color:var(--color-global-grey700);border-color:var(--color-global-grey400);background:linear-gradient( to left top,var(--color-global-white) calc(50% - 1px),var(--color-global-grey400),var(--color-global-white) calc(50% + 1px) );}"], function (_ref) {
  var swatchColour = _ref.swatchColour,
    swatchImage = _ref.swatchImage;
  return swatchColour || swatchImage ? "\n\t\t\t\tjustify-content: left;\n\t\t\t\ttext-align: left;\n\t\t\t" : "\n\t\t\t\tjustify-content: center;\n\t\t\t\ttext-align: center;\n\t\t\t";
});
var StyledSwatch = (0, _styledComponents["default"])(_index.Swatch).withConfig({
  displayName: "src__StyledSwatch",
  componentId: "sc-15hfvdh-2"
})(["margin:0 var(--spacing-global-space3) 0 0;vertical-align:middle;flex-basis:20px;flex-grow:0;flex-shrink:0;"]);

// Question: What should happen when you have long text that wraps around 3 lines?
function OptionSelector(_ref2) {
  var dataTestId = _ref2.dataTestId,
    id = _ref2.id,
    name = _ref2.name,
    label = _ref2.label,
    swatchColour = _ref2.swatchColour,
    swatchImage = _ref2.swatchImage,
    props = _objectWithoutProperties(_ref2, _excluded);
  var disabled = props.disabled;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledInput, _extends({
    "data-testid": dataTestId,
    type: "radio",
    id: id,
    name: name
  }, props, {
    "aria-disabled": disabled ? 'true' : 'false'
  })), /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    swatchColour: swatchColour,
    swatchImage: swatchImage,
    htmlFor: id
  }, (swatchColour || swatchImage) && /*#__PURE__*/_react["default"].createElement(StyledSwatch, {
    colour: swatchColour,
    imageSrc: swatchImage
  }), /*#__PURE__*/_react["default"].createElement("span", null, label)));
}
OptionSelector.propTypes = propTypes;
OptionSelector.defaultProps = defaultProps;
var _default = exports["default"] = OptionSelector;